// eslint-disable-next-line no-extend-native
String.prototype.toCapitalize = function (): string {
  if (!this.length) return ''
  return this.charAt(0).toUpperCase() + this.slice(1)
}

export {}
